function ArrowIcon(props)
{
    return(
        <svg className={props.class} viewBox="0 0 24 24">
  <polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"/>
</svg>
    )
}

export default ArrowIcon